import * as React from 'react';
import { Product } from '~/Api/Product';
import { List } from '~/Api/User/ProductGroup/CzReimbursement';

export const ProductProvider: React.FunctionComponent<
	React.PropsWithChildren<{
		czReimbursement: List | null;
		id: string;
		children(product: Product | null): React.ReactNode;
	}>
> = ({ czReimbursement, id, children }) => {
	const product = React.useMemo(
		() => czReimbursement?.products.find((candidate) => candidate.product.id === id)?.product ?? null,
		[czReimbursement, id]
	);
	return <>{children(product)}</>;
};

ProductProvider.displayName = 'CzReimbursement.ProductProvider';
